import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPowerOff, FaArrowLeft, FaHome } from "react-icons/fa";

import { useSettings } from '../../context/SettingsContext'

const Nav = ({}) => {
  return (
    <nav className="w-full flex flex-col justify-between items-center fixed z-50">
      <div className="w-full mx-auto items-center flex justify-between lg:flex-nowrap bg-primary flex-wrap lg:px-6 px-4">
        <h1>Valparx Validation</h1>
      </div>
    </nav>
  )
}

export default Nav;
